import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Params = {
  text: string;
};

export const copyToClipboard = createAppAsyncThunk(
  'clipboard/copyToClipboard',
  async ({ text }: Params, { extra: { snackbarGateway } }): Promise<void> => {
    navigator.clipboard.writeText(text);
    snackbarGateway.success(translate('CopyToClipboard.Message.success'));
  },
);
